import React, { Component } from "react";
import { connect } from "react-redux";

import withStyles from "@material-ui/styles/withStyles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import DownloadsIcon from "@material-ui/icons/GetApp";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Tooltip from "@material-ui/core/Tooltip";

import { PageHeader, SimpleForm, TextInput, RestMethods, FETCH_START, FETCH_END, Button, required, showNotification } from "jazasoft";

import Table from "../../components/Table";
import { dataProvider } from "../../App";
import handleError from "../../utils/handleError";
import { Card, Drawer } from "@material-ui/core";
import { inputOptions } from "../../utils/helpers";

const styles = theme => ({
  root: {
    margin: theme.spacing(3)
  },
  cardPadding: {
    padding: theme.spacing(3)
  },
  drawerHeader: {
    width: 500,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: theme.spacing(2)
  },
  headerCell: {
    padding: "12px",
    fontSize: 14,
    "&:last-child": {
      padding: "12px",
      fontSize: 14
    }
  },
  rowCell: {
    padding: "12px 16px",
    fontSize: 14,
    "&:last-child": {
      padding: "12px 16px",
      fontSize: 14
    }
  }
});

const ActionItem = ({ tooltip, icon, onClick }) => (
  <Tooltip title={tooltip} onClick={onClick}>
    <IconButton aria-label={tooltip}>{icon}</IconButton>
  </Tooltip>
);

class Downloads extends Component {
  state = {
    busy: false,
    drawerState: { open: false, agmId: null }
  };

  onDownload = name => () => {
    this.setState({ busy: true });
    const options = {
      url: `templates`,
      method: "get",
      params: { name },
      responseType: "arraybuffer"
    };

    this.props.dispatch({ type: FETCH_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          const header = response.headers["content-disposition"];
          var filename = header ? header.match(/filename="(.+)"/)[1] : name + ".xlsx";

          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        }
        this.props.dispatch({ type: FETCH_END });
        this.setState({ busy: false });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.setState({ busy: false });
      });
  };

  onDbBackup = () => {
    this.setState(prev => ({ ...prev, drawerState: { open: true, agmId: null } }));
  };

  onDrawerClose = () => {
    this.setState(prev => ({ ...prev, drawerState: { open: false, agmId: null } }));
  };

  onSubmit = values => {
    this.setState({ busy: true });
    const options = {
      url: `dev/db-backup`,
      method: "post",
      params: { agmId: values?.agmId || "" }
    };

    this.props.dispatch({ type: FETCH_START });
    dataProvider(RestMethods.CUSTOM, undefined, options)
      .then(response => {
        if (response.status === 200) {
          this.onDrawerClose();
          this.props.dispatch(showNotification(response?.data || ""));
        }
        this.props.dispatch({ type: FETCH_END });
        this.setState({ busy: false });
      })
      .catch(err => {
        handleError(err, this.props.dispatch);
        this.props.dispatch({ type: FETCH_END });
        this.setState({ busy: false });
      });
  };

  render() {
    const { classes } = this.props;
    const columns = [
      { title: "Name", dataKey: "name" },
      { title: "", dataKey: "action", align: "right" }
    ];

    const rows = [
      {
        name: "Order Upload Template",
        action: (
          <ActionItem
            tooltip="Download"
            icon={<DownloadsIcon />}
            disabled={this.state.busy}
            onClick={!this.state.busy ? this.onDownload("ORDER_UPLOAD") : null}
          />
        )
      },
      {
        name: "Fabric Upload Template",
        action: (
          <ActionItem
            tooltip="Download"
            icon={<DownloadsIcon />}
            disabled={this.state.busy}
            onClick={!this.state.busy ? this.onDownload("FABRIC_UPLOAD") : null}
          />
        )
      },
      {
        name: "Roll Upload Template",
        action: (
          <ActionItem
            tooltip="Download"
            icon={<DownloadsIcon />}
            disabled={this.state.busy}
            onClick={!this.state.busy ? this.onDownload("ROLL_UPLOAD") : null}
          />
        )
      },
      {
        name: "Cu Checklist Template",
        action: (
          <ActionItem
            tooltip="Download"
            icon={<DownloadsIcon />}
            disabled={this.state.busy}
            onClick={!this.state.busy ? this.onDownload("CU_CHECKLIST") : null}
          />
        )
      },
      {
        name: "User Upload Template",
        action: (
          <ActionItem
            tooltip="Download"
            icon={<DownloadsIcon />}
            disabled={this.state.busy}
            onClick={!this.state.busy ? this.onDownload("USER_UPLOAD") : null}
          />
        )
      },
      {
        name: "Invoice Upload Template",
        action: (
          <ActionItem
            tooltip="Download"
            icon={<DownloadsIcon />}
            disabled={this.state.busy}
            onClick={!this.state.busy ? this.onDownload("INVOICE_UPLOAD") : null}
          />
        )
      }
    ];

    return (
      <div>
        <Drawer anchor="right" open={this.state.drawerState.open} onClose={this.onDrawerClose}>
          <div className={classes.drawerHeader}>
            <IconButton onClick={this.onDrawerClose}>
              <ChevronRightIcon />
            </IconButton>
            <div>
              <Typography variant="h5">DB Backup against AGM ID</Typography>
            </div>
          </div>
          <Divider />

          <Card className={classes.cardPadding}>
            <SimpleForm onSubmit={this.onSubmit} saving={this.state.busy}>
              <TextInput label="AGM ID" source="agmId" validate={required()} {...inputOptions(12)} />
            </SimpleForm>
          </Card>
        </Drawer>

        <PageHeader title="Templates" />

        <Paper className={classes.root}>
          <Table classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }} columns={columns} rows={rows} />
        </Paper>

        <div style={{ display: "flex", justifyContent: "center", margin: "1.5em" }}>
          <Button label="APK download" variant="contained" onClick={() => this.props.history.push("/Apk")} color="primary" />
          <div style={{ marginLeft: "1.5em" }}>
            <Button label="DB Backup" variant="contained" onClick={this.onDbBackup} color="primary" />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(connect()(Downloads));
